<template>
  <div class="remind-list-trend">
    <div class="flex-align-center" style="margin-bottom: 20px">
      <img
        src="@/assets/imgs/school/monthRecord/rank.png"
        alt=""
        style="width: 24px; height: 24px; margin-right: 15px"
      />
      <div class="record-title">全校提醒名单人数变化趋势</div>
    </div>
    <!--每周提醒人数/关怀数柱状图-->
    <BarChart
      height="300px"
      :fields="fields"
      :dataSource="dataSource"
      :color="['#FBB040', '#5BBE7A']"
    />
    <!--趋势分析-->
    <div class="analyse-card">
      <div class="flex-align-center" style="margin-bottom: 10px">
        <img
          src="@/assets/imgs/school/monthRecord/analyse.png"
          alt=""
          style="width: 14px; height: 14px; margin-right: 5px"
        />
        <span>趋势分析：</span>
      </div>
      <div class="analyse-item">
        本月总提醒人数{{ trendText.totalRemindCount }}人，已处理{{
          trendText.processedCount
        }}人，提醒人数最多的是{{ trendText.maxRemindWeekDate }}的这周，共提醒{{
          trendText.maxRemindWeekCount
        }}人，提醒人数最少的是{{ trendText.minRemindWeekDate }}的这周，共提醒{{
          trendText.minRemindWeekCount
        }}人，总体上相比上个月的提醒名单呈现下降趋势
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/echartZyz/components/BarChart'
import { getSchoolWarningTrend } from '@api/monthReport'
import moment from 'moment'

export default {
  name: 'RemindListTrend',
  components: {
    BarChart,
  },
  props: {
    dateRange: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 图例（与数据源中的键名一一对应）
      fields: ['每周提醒人数', '每周关怀数'],
      // 柱状图数据：每周提醒人数/关怀数
      dataSource: [],
      // 趋势分析文本（接口返回后填充）
      trendText: {
        totalRemindCount: '--',
        processedCount: '--',
        maxRemindWeekDate: '--',
        maxRemindWeekCount: '--',
        minRemindWeekDate: '--',
        minRemindWeekCount: '--',
      },
    }
  },
  watch: {
    dateRange: {
      immediate: true,
      handler(dateObj) {
        if (dateObj && dateObj.beginDate) {
          this.queryTrend({
            startTime: dateObj.beginDate,
            endTime: dateObj.endDate,
          })
        }
      },
    },
  },
  methods: {
    async queryTrend(params) {
      const { success, result } = await getSchoolWarningTrend(params)
      if (success && result) {
        // 柱状图：按周聚合，字符串数值转 Number
        this.dataSource = (result.weeklyList || []).map((item) => ({
          type: item.date,
          每周提醒人数: Number(item.weekRemindCount || 0),
          每周关怀数: Number(item.weekCareCount || 0),
        }))
        // 趋势分析文案
        this.trendText = {
          totalRemindCount: result.totalRemindCount || '--',
          processedCount: result.processedCount || '--',
          maxRemindWeekDate: this.formatDate(result.maxRemindWeekDate),
          maxRemindWeekCount: result.maxRemindWeekCount || '--',
          minRemindWeekDate: this.formatDate(result.minRemindWeekDate),
          minRemindWeekCount: result.minRemindWeekCount || '--',
        }
      }
    },
    // 日期格式化为 YYYY年MM月DD日
    formatDate(date) {
      return date ? moment(date).format('YYYY年MM月DD日') : '--'
    },
  },
}
</script>

<style scoped lang="less">
.remind-list-trend {
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  .analyse-card {
    padding: 20px;
    margin-top: 15px;
    border-radius: 10px;
    background-color: #f9fafb;
    font-weight: 500;
    color: #383838;
    line-height: 2;
    .analyse-item {
      letter-spacing: 0.5px;
      &:before {
        content: '';
        display: inline-block;
        width: 5px;
        height: 5px;
        margin-right: 10px;
        border-radius: 50%;
        background-color: #383838;
        vertical-align: middle;
      }
    }
  }
}
</style>
